import React from "react";
import style from "./Contact.module.css";
import { GoLocation } from "react-icons/go";
import { BiPhoneCall } from "react-icons/bi";
import location from "../../img/location.png";

function Contact() {
  return (
    <>
      <div className={style.divContact + " container mb-4"}>
        <div className="row">
          <div className="col-12">
            <h1 className=" text-center text-muted">
              Los esperamos en Colón esq Ansina <GoLocation />
            </h1>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className={style.locationContainer + " col-10"}>
            <img src={location} className="img-fluid" alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="text-muted">
              También tenemos delivery <BiPhoneCall />
            </h2>
            <h2 className="text-muted">Sólo whatsapp 099999999</h2>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
